/**
 * MotionRoot — loads the small `domAnimation` feature set once (LazyMotion + `m`)
 * (lazy-loaded after first paint) and makes every animation honour the OS "reduce motion" setting
 * (transforms are dropped, opacity fades remain).
 */
import { LazyMotion, MotionConfig } from "motion/react";

const loadFeatures = () => import("@/lib/motion-features").then((mod) => mod.default);
import type { ReactNode } from "react";

export function MotionRoot({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={loadFeatures} strict>
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </LazyMotion>
  );
}
